import { render } from "./OverlayBanner.vue?vue&type=template&id=1a3fcf4a"
import script from "./OverlayBanner.vue?vue&type=script&lang=js"
export * from "./OverlayBanner.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__